import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import { TXTWCL_OopsX_No_Games_Found } from './NoGamesFound.messages.json';
import styles from './NoGamesFound.scss';
import Dice from './assets/svg-dice.svg';

const NoGamesFound: React.FC = () => (
  <div className={styles.message}>
    <div className={styles.noGames}>
      <Dice />
      <div className={styles.oops}>
        <Translation {...TXTWCL_OopsX_No_Games_Found} />
      </div>
    </div>
  </div>
);

export default NoGamesFound;
